import styled from "styled-components"
import regist from '@/img/user-new/regist.png'
import close from '@/img/user-new/close.png'
import titileBack from '@/img/user-new/title-back.png'
import descBack from '@/img/user-new/share-desc.png'
import {tab_bg_color,color1,bg_color1,activity_state_color, card_bg_color, box_shadow} from '@/styles/theme'
export const InvitationContainer = styled.div`
  margin-top: 84px;
  min-height: calc(100vh - 84px);
  box-sizing: border-box;
`
export const Content = styled.div`
  min-height: calc(100vh - 86px);
  margin: ${props=> props.justy? '20px 8px 20px ' : '40px 16px 20px'} ;
  .am-pull-to-refresh{
    &::-webkit-scrollbar {
      display: none; 
    }
  }
  .am-pull-to-refresh-indicator{
    font-size: 12px;
  }
  /* .am-pull-to-refresh-up .am-pull-to-refresh-indicator{
    padding: 10px; 
  } */
  .am-pull-to-refresh-content-wrapper{
    min-height: calc(100vh - 80px);
  }
`

export const Card  = styled.div`
  width:100%;
  padding: 10px 16px;
  box-sizing: border-box;
  margin-top: 14px;
  background: ${tab_bg_color};
  border-radius: 6px;
  .title{
    margin-bottom: 6px;
    font-size: 15px;
    font-weight: 500;
    color: ${color1};
    line-height: 21px;
  }
  .date{
    font-size: 13px;
    color: #9696A6;
    font-weight: 400;
  }
`


// 分享H5样式 

export const ShareContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #fbf1e4;
  background-image: url('https://file.wogoo.com/image/activity/share.png');
  background-repeat: no-repeat;
  background-size: contain;
  padding-top: 52.8vw;
  background-position: 0 0;
  .bg-img{
    width: 100%;
  }
  .tip{
    margin-top: -25px;
    font-size: 12px;
    text-align: center;
    color: #9696a6;
  }
`

export const RegistContainer = styled.div`
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  .container{
    width: 100%;
    padding: 24px;
    display: ${props=>props.Empty? 'flex':'block '};
    justify-content: center;
    align-items: ${props=>props.Empty?  'baseline':'center'};
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 2px 16px 0px rgba(255, 140, 137, 0.34);
    border-radius: 16px;
  }
  .name-container{
    margin-bottom: 11px;
  }
  .name{
    display: flex;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    color: #fe360c;
    line-height: 28px;
    z-index: 999;
    text-align: center;
  }
  .info{
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
    line-height: 26px;
    text-align: justify;
  }
`

export const FormCotainer = styled.div`
  .form-item{
    margin: 10px 0;
    padding: 14px 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    background: #F6F6F8;
    border-radius: 6px;
    .am-list-item{
      width: 100%;
    }
    .am-list-item:not(:last-child) .am-list-line::after{
      background-color: transparent;
    }
    .am-list-item:not(:last-child) .am-list-line {
      border: none;
    }
    .am-list-item .am-input-clear{
      background-image: url(${close});
      background-color: transparent;
      background-size : 21px;
      background-position: 0 0;
      border-radius: 0;
    }
    .button{
      margin-left: 10px;
      width: 94px;
      text-align: right;
      background: #F6F6F8;
      border: none;
      outline: none;
      color: #9696A6;
    }
    .active{
      color: #ffb000;
    }
  }
  .am-list-item.am-input-item{
    padding-left: 2px;
  }
  .am-list-item{
    background: #F6F6F8;
    .am-input-label{
      width: 32px;
      font-size: 14px;
      color: #333;
    }
    .am-input-control input {
      font-size: 16px;
      color: #333;
    }
    .am-input-label{
      position: relative;
      overflow: visible;
    }
    .am-input-label:before{
      position: absolute;
      content: '';
      right: -1px;
      top: -2px;
      width: 1px;
      height: 24px;
      background: #979797;
      transform: scale(0.8);
    }
  }
  .text{
      flex: 1;
      background: #F6F6F8;
      border: none;
      outline: none;
      .am-input-control input{
        font-size: 14px;
      }
    }
  .regist{
    margin-top: 16px; 
    width: 100%;
    height: 58px;
    border: none;
    outline: none;
    font-weight: 500;
    color: #fff;
    background: url(${regist}) no-repeat center;
    background-size: 100%;
  }
  
`

export const Desc = styled.div`
  padding: 15px;
  width: 100vw;
  box-sizing: border-box;
  position: relative;
  .desc-img {
    width: 100%;
  }
  .title {
    position: absolute;
    top: 12px;
    left: 24px;
    right: 24px;
    background-image: url(${descBack});
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 63px;
    text-align: center;
    line-height: 44px;
    font-size: 14px;
    color: #fff;
  }
  .lock {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
  }
  .desc-bottom {
    position: absolute;
    left: 50%;
    width: 270px;
    transform: translateX(-50%);
    bottom: 15.42%;
    color: #fff;
    text-align: center;
    .desc1 {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 12px;
      font-weight: 600;
    }
    .desc2 {
      font-size: 12px;
      line-height: 26px;
    }
  }
`

export const RegistModalContent = styled.div`
  .regist-modal-content-text{
    text-align: center∂;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #333;
  }
  .regist-modal-content-group{
    margin: 24px auto 0;
    display: flex;
    justify-content: space-around;
  }
  .regist-modal-content-button{
    width: 100%;
    font-size: 14px;
    text-align: center;
    line-height: 54px;
    color: #ffff;
    font-weight: 500;
    border-radius: 20px;
    border:none;
    background: url(${regist}) no-repeat center;
    background-size: 100%;
  }
  .regist-modal-button{
    display: flex;
    align-items: center;
    .regist-modal-close{
      margin: 0 5px;
      width: 110px;
    }
  }
    
`
export const ActivtyContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 44px;
  /* margin-bottom: 40px; */
  min-height: calc(100vh - 84px);
  background: ${bg_color1};
  box-sizing: border-box;
`
export const ActiveCard = styled.div`
  width: calc(100% - 20px);
  margin: 6px auto 24px;
  box-sizing: border-box;
  background: ${card_bg_color};
  box-shadow: ${box_shadow};
  border-radius: 6px;
  .img-container{
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: 6px 6px 0 0;
    img{
      border-radius: 6px 6px 0 0;
      width: 100%;
      height: 100%;
      filter: ${props=>props.state=== 2? 'grayscale(100%) saturate(0.1)': 'none'};
    }
    .activity-state{
      position: absolute;
      top: 0;
      left: 0;
      &:before{
        position: absolute;
        content: '活动已结束';
        font-size: 12px;
        font-weight: 600;
        color: ${activity_state_color}; 
        top: 0;
        left: 0;
        z-index: 999;
        width:88px;
        height: 32px;
        background: ${card_bg_color};
        border-radius: 5px 0px 16px 0px;
        line-height: 32px;
        text-align: center;
      }
    }
  }
  .content{
    padding: 16px;
    .title{
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
      color: ${color1};
      line-height: 20px;
    }
    .date{
      font-size: 12px;
      font-weight: 400;
      color: #646472;
      line-height: 17px;
    }
  }
`


export const CTitle = styled.div`
  .title{
    position: absolute;
    top:  0;
    top: 0;
    left: 45px;
    right: 45px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #511e21;
    font-weight: 600;
    background-image: url(${titileBack});
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .back{
    width: calc(100% - 62px);
    height: 10px;
    position: absolute;
    top: 0;
    left: 31px;
    overflow: hidden;
    &:before{
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 29px;
      border-radius: 15px;
      background-color: #c93432;
    }
  }
  .prize-header{
    position: absolute;
    height: 81px;
    top: -74px;
    left: 50%;
    transform: translateX(-50%);
  }
`


export const Center =styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

`


// WEBPACK FOOTER //
// ./src/styles/acitvityInfo.js